import { FC, JSX } from "react";
import { convertTextToKebabCase } from "@app/shared/utility/convertTextToKebabCase";
import { OutlineBadge, OutlineBadgeColor } from "@app/shared/OutlineBadge";

interface QHPMarketCoverageBadgesProps {
  marketCoverage: string;
}

// Keyed on the upper-cased market name, which is also what the badge displays. Any value silver
// starts publishing that isn't mapped here still renders, just unstyled, rather than disappearing.
const MARKET_COVERAGE_BADGE_COLORS: Record<string, OutlineBadgeColor> = {
  INDIVIDUAL: OutlineBadgeColor.Yellow,
  SHOP: OutlineBadgeColor.Orange,
};

// Market coverage arrives as a single string: "Individual", "SHOP", or "Individual / SHOP" for a
// contract that genuinely serves both markets. Split it so each market gets its own badge,
// preserving the order the data supplies. The column is nullable, so an empty value is expected
// for any enrichment version ingested before the market coverage column existed.
const QHPMarketCoverageBadges: FC<QHPMarketCoverageBadgesProps> = ({ marketCoverage }): JSX.Element => {
  const markets = (marketCoverage ?? "")
    .split("/")
    .map(market => market.trim())
    .filter(market => !!market);

  if (!markets.length) {
    return <>---</>;
  }

  return (
    <>
      {markets.map(market => {
        const displayText = market.toUpperCase();

        return (
          <OutlineBadge
            color={MARKET_COVERAGE_BADGE_COLORS[displayText] ?? OutlineBadgeColor.Plain}
            key={market}
            testId={`qhp-network-flyout__market-coverage-${convertTextToKebabCase(market)}`}
          >
            {displayText}
          </OutlineBadge>
        );
      })}
    </>
  );
};

export default QHPMarketCoverageBadges;
